import moment from "moment";

export const formattedDate = (date) => {
	if (!date) {
		return '';
	}

	return moment(date?.toString()?.replace('T',' ')?.replace('Z',' ')).utc().format("YYYY/MM/DD");
};

export const formattedAge = (date) => {
	if (!date) {
		return '';
	}
	
	var years = moment().utc().diff(date?.toString()?.replace('T',' ')?.replace('Z',' '), 'years');
	if(years > 1){
		return years + ' yr';
	}

	var months = moment().utc().diff(date?.toString()?.replace('T',' ')?.replace('Z',' '), 'months');
	if(months > 1){
		return months + ' mn';
	}

	var days = moment().utc().diff(date?.toString()?.replace('T',' ')?.replace('Z',' '), 'days');
	return days + ' ds';
};

export const formattedTime = (date) => {
	if (!date) {
		return;
	}

	return moment(date?.toString()?.replace('T',' ')?.replace('Z',' ')).utc().format("HH:mm");
};

export const formattedDateTime = (date) => {
	if (!date) {
		return;
	}
	return moment(date?.toString()?.replace('T',' ')?.replace('Z',' ')).utc().format("YYYY/MM/DD - HH:mm");
};

export const formatUNIXtoAMPM = (unix) => {
	if (!unix) return;
	
	return moment(Number(unix)).utc().format("hh:mm A");
};
export default formattedDate;
